type LoginStep = 'name' | 'method' | 'otp' | 'password' | 'success';

const BACK_STEP_MAP: Record<LoginStep, LoginStep | null> = {
  name: null,
  method: 'name',
  otp: 'method',
  password: 'method',
  success: null,
};

/**
 * Returns the previous step for back navigation, or null if no back is possible.
 */
export function getBackStep(step: LoginStep): LoginStep | null {
  return BACK_STEP_MAP[step];
}
